import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { queryClient } from "@/lib/query";
import { router } from "./router";
import "./styles.css";

// A lazy chunk from a build this tab no longer matches failed to load (e.g. right after a deploy):
// reload once to pick up the current index.html. The timestamp guard stops a reload loop.
window.addEventListener("vite:preloadError", (event) => {
  try {
    const last = Number(sessionStorage.getItem("baze:chunk-reload") ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem("baze:chunk-reload", String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

async function boot() {
  // Development-only in-browser API mock (VITE_MOCK_API=1). Dead-code-eliminated in production builds.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === "1") {
    const { installMockApi } = await import("./mock");
    installMockApi();
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
